import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./Auth";

import Header from "./components/Header";
import DataEntry from "./components/layouts/admin/data-entry/DataEntry";
import { LocationData } from "./components/layouts/location-data";
import { Login } from "./components/layouts/login";
import { SearchForm } from "./components/layouts/search";
import { PrivateRoute } from "./PrivateRoute";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Header />
        <Routes>
          <Route path="/" element={<SearchForm />} />
          <Route path="/:locationId" element={<LocationData />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <DataEntry />
              </PrivateRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </div>
  );
}

export default App;
